import * as Yup from "yup";
import { messages } from "../../../common/Models/Validations";

// Helper function to check if visitor type should be optional based on user role
const shouldVisitorTypeBeOptional = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userRole = user?.current_role?.name;
  return userRole === 'receptionist' || userRole === 'assistant';
};

export const ticketTypes = [
  { name: "National", id: "national" },
  { name: "International", id: "international" },
  { name: "Student", id: "student" },
  { name: "Monk", id: "monk" },
  { name: "Official", id: "official" },
  { name: "Children", id: "children" },
];

export const ticketInitialValue = {
  museum_id: null,
  nationality: "",
  nationality_other: "",
  no_of_visitor: null,
  validity:"",
  payment_due: "",
  payment_type: "electronic",
  transaction_no: "",
  visitor_type_id: null,
  ticket_type_id: null,
  withGuide: "no",
  guide_id: null,
  guide_name: "",
  guide_phone: "",
  guide_agent_name: "",
  exhibition_ids: [],
  translations: {
    en: {
      remarks: "",
      refund_notes: "",
    },
  },
};

export const customerTicketValidation = Yup.object().shape({
  nationality: Yup.string().required(messages.required),
  no_of_visitor: Yup.string().required(messages.required),
  museum_id: Yup.string().required(messages.required),
  visitor_type_id: Yup.mixed().required(messages.required),
  ticket_type_id: Yup.mixed().nullable().notRequired(),
  exhibition_ids: Yup.array().of(Yup.number()),
  payment_type: Yup.string().oneOf(["cash", "electronic"]).required(messages.required),
});

export const ticketValidation = Yup.object().shape({
  nationality: Yup.string().required(messages.required),
  no_of_visitor: Yup.string().required(messages.required),
  museum_id: Yup.string().required(messages.required),
  visitor_type_id: Yup.string().when([], {
    is: () => !shouldVisitorTypeBeOptional(),
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
  ticket_type_id: Yup.number().required(messages.required),
  withGuide: Yup.string().oneOf(["yes", "no"]).required(messages.required),
  guide_id: Yup.number().nullable(),
  guide_name: Yup.string().when(["withGuide", "guide_id"], {
    is: (withGuide, guideId) => withGuide === "yes" && !guideId,
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
  guide_phone: Yup.string().when(["withGuide", "guide_id"], {
    is: (withGuide, guideId) => withGuide === "yes" && !guideId,
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
  guide_agent_name: Yup.string().notRequired(),
  exhibition_ids: Yup.array().of(Yup.number()),
  payment_type: Yup.string().oneOf(["cash", "electronic"]).required(messages.required),
  transaction_no: Yup.string().when("payment_type", {
    is: "electronic",
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
});
